import { ReactNode, useCallback, useEffect, useState } from "react";
import { DialogContext } from "./DialogContext";

export const DialogProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  /**
   * Dialogs
   */
  const [dialogs, setDialogs] = useState<ReactNode[]>([]);
  const openDialog = useCallback((dialog: ReactNode) => {
    setDialogs((dialogs) => [...dialogs, dialog]);
  }, []);
  const closeDialog = useCallback(() => {
    setDialogs((dialogs) => dialogs.slice(0, -1));
  }, []);

  // Functions to enable and disable scroll in the page.
  function disableScroll() {
    document.body.style.overflow = "hidden";
  }
  function enableScroll() {
    document.body.style.overflow = "unset";
  }

  // Use Effect to handle scroll enabling and disabling, based on dialog display.
  useEffect(() => {
    if (dialogs.length > 0) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [dialogs]);

  return (
    <DialogContext.Provider
      value={{ dialogs: dialogs.map((dialog, index) => <div key={index}>{dialog}</div>), openDialog, closeDialog }}
    >
      {children}
    </DialogContext.Provider>
  );
};
